<template>
  <footer class="container-fluid">
    <div class="row footerguest">
      <div class="col-sm-6 text-left">
        <p>MovilEuros@2020 Copyright</p>
      </div>
      <div class="col-sm-6 text-right">
        <p>
          <!-- <router-link totarget="_blank">{{ $t('privacy_policy')}}</router-link>
          <router-link target="_blank">{{ $t('legal_para')}}</router-link>
          <router-link target="_blank">{{ $t('cookies_policy')}}</router-link> -->
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>
